import { PropsWithChildren, useMemo } from 'react'
import { routesWithoutLayout } from '../cnst/router.cnst'
import { useLocation } from 'react-router'
import Navbar from './Navbar'
import FreeTierBanner from './FreeTierBanner'
import { useCustomer } from '../utils/hooks'
import FreeTierExpiredOverlay from './FreeTierExpiredOverlay'

const Layout = ({ children }: PropsWithChildren) => {
  const location = useLocation()
  const customer = useCustomer()

  const shouldRenderLayout = useMemo(() => {
    let pathname = location.pathname.toLowerCase()
    if (pathname.endsWith('/')) {
      pathname = pathname.slice(0, -1)
    }

    return !routesWithoutLayout.some((route) => {
      if (route.includes(':')) {
        return pathname.startsWith(route.split(':')[0])
      }
      return route.toLowerCase() === pathname
    })
  }, [location])

  const freeTierIsExpired = useMemo(() => {
    if (!customer?.freeTierExpiryDate) return false
    return (
      new Date(customer.freeTierExpiryDate).getTime() < new Date().getTime()
    )
  }, [customer?.freeTierExpiryDate])

  if (freeTierIsExpired) return <FreeTierExpiredOverlay />

  if (!shouldRenderLayout) return children

  return <_Layout>{children}</_Layout>
}

export default Layout

const _Layout = ({ children }: PropsWithChildren) => {
  return (
    <>
      <FreeTierBanner />
      <Navbar />
      <main className='bg-slate-50 min-h-screen'>{children}</main>
    </>
  )
}
